import { useCallback } from "react";

import { useTrackImpressionEventByIntersection } from "~/components/tracking";
import type { Event } from "~/components/tracking/google-analytics/types";

export const commentHash = "#comments";

export const useTopStoriesImpressionTracking = () => {
  const firstSetImpressionEvent = useCallback<() => Event>(
    () => ({
      action: "Impression/top_story_6",
      category: "Homepage Depth",
    }),
    [],
  );
  const {
    captureTrackImpressionEventTargetElement: captureTrackImpressionEventTargetFirstSetElement,
  } = useTrackImpressionEventByIntersection({
    getEvent: firstSetImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  const secondSetImpressionEvent = useCallback<() => Event>(
    () => ({
      action: "Impression/top_story_9",
      category: "Homepage Depth",
    }),
    [],
  );
  const {
    captureTrackImpressionEventTargetElement: captureTrackImpressionEventTargetSecondSetElement,
  } = useTrackImpressionEventByIntersection({
    getEvent: secondSetImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  const thirdSetImpressionEvent = useCallback<() => Event>(
    () => ({
      action: "Impression/top_story_13",
      category: "Homepage Depth",
    }),
    [],
  );
  const {
    captureTrackImpressionEventTargetElement: captureTrackImpressionEventTargetThirdSetElement,
  } = useTrackImpressionEventByIntersection({
    getEvent: thirdSetImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  const fourthSetImpressionEvent = useCallback<() => Event>(
    () => ({
      action: "Impression/top_story_17",
      category: "Homepage Depth",
    }),
    [],
  );
  const {
    captureTrackImpressionEventTargetElement: captureTrackImpressionEventTargetFourthSetElement,
  } = useTrackImpressionEventByIntersection({
    getEvent: fourthSetImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  const firstFoldImpressionEvent = useCallback<() => Event>(
    () => ({
      action: "Impression/first_fold",
      category: "Homepage Depth",
    }),
    [],
  );
  const {
    captureTrackImpressionEventTargetElement: captureTrackImpressionEventTargetFirstFoldElement,
  } = useTrackImpressionEventByIntersection({
    getEvent: firstFoldImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  const secondFoldImpressionEvent = useCallback<() => Event>(
    () => ({
      action: "Impression/second_fold",
      category: "Homepage Depth",
    }),
    [],
  );
  const {
    captureTrackImpressionEventTargetElement: captureTrackImpressionEventTargetSecondFoldElement,
  } = useTrackImpressionEventByIntersection({
    getEvent: secondFoldImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  const thirdFoldImpressionEvent = useCallback<() => Event>(
    () => ({
      action: "Impression/third_fold",
      category: "Homepage Depth",
    }),
    [],
  );
  const {
    captureTrackImpressionEventTargetElement: captureTrackImpressionEventTargetThirdFoldElement,
  } = useTrackImpressionEventByIntersection({
    getEvent: thirdFoldImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  return {
    captureTrackImpressionEventTargetFirstFoldElement,
    captureTrackImpressionEventTargetFirstSetElement,
    captureTrackImpressionEventTargetFourthSetElement,
    captureTrackImpressionEventTargetSecondFoldElement,
    captureTrackImpressionEventTargetSecondSetElement,
    captureTrackImpressionEventTargetThirdFoldElement,
    captureTrackImpressionEventTargetThirdSetElement,
  };
};
